import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ListStylingWrapper = styled.div`
    position: relative;
    ${ (props) => {
        if (props.responsive && props.responsive === 'scroll') {
            return `
                overflow-x: scroll;
            `;
        }
    } }
`;

const StyledTable = styled.table`
    border-collapse: collapse;
    margin: 0;
    width: 100%;
    min-width: 500px;
    font-size: 13px;
    overflow: hidden;
`;

const Table = (props) => {
    const {
        children,
        responsive,
    } = props;

    return (
        <ListStylingWrapper responsive={ responsive }>
            <StyledTable>
                <tbody>
                    { children }
                </tbody>
            </StyledTable>
        </ListStylingWrapper>
    );
};

Table.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.node,
        PropTypes.array,
    ]).isRequired,
    responsive: PropTypes.string,
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/ui/table/Table.js